import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { DrawResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The tournament's PUBLIC draws list (GET /tournaments/{id}/draws →
 * DrawResponse[], anonymous-readable). This is a SEPARATE query from the main
 * detail fetch, with its OWN loading/error — so the Draws section is isolated
 * (mirrors useTournamentEvents): a failing draws fetch surfaces the section's
 * own role="alert" while the main detail (name / schedule) still renders. The
 * page renders the server's order verbatim — no client re-sort, no derived
 * counts.
 */
export function useTournamentDraws(tournamentId: string | undefined) {
  return useQuery<DrawResponse[]>({
    queryKey: queryKeys.tournaments.draws(tournamentId ?? ""),
    queryFn: () => tournamentApi.listDraws(tournamentId as string),
    enabled: Boolean(tournamentId),
  });
}
